import { api, downloadFile } from './client';

export interface DocumentAttachmentDto {
  id: number;
  entityType: string;
  entityId: number;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
  uploadedAt: string;
  uploadedBy: string;
}

/**
 * Document attachments (source documents, agreements…) tied to an entity
 * (InvoiceMade / InvoiceReceived / …). Backend keeps files for the legally
 * mandated retention period; deletes are soft.
 */
export const attachmentsApi = {
  list: (entityType: string, entityId: number) =>
    api.get<DocumentAttachmentDto[]>('/attachments', { entityType, entityId }),

  upload: (entityType: string, entityId: number, file: File) => {
    const form = new FormData();
    form.append('entityType', entityType);
    form.append('entityId', String(entityId));
    form.append('file', file);
    return api.upload<number>('/attachments', form);
  },

  download: (attachment: DocumentAttachmentDto) =>
    downloadFile(`/attachments/${attachment.id}/download`, attachment.fileName),

  remove: (id: number) =>
    api.delete<void>(`/attachments/${id}`),
};
